<!-- eslint-disable vue/html-self-closing -->
<template>
  <div>
    <custom-select
      v-model="selectedModel"
      class="select select-branch"
      :options="options"
      :placeholder="placeholder"
      :searchable="true"
      :filterable="false"
      :clearable="clearable"
      clear-search-on-select="false"
      :error="error"
      @input="onChange"
      @open="onOpen"
      @close="onClose"
      @search="onSearch"
    >
      <template #footer>
        <li
          v-show="showLoader"
          ref="load"
          class="select-branch__loader text-muted"
        >
          Загрузка...
        </li>
      </template>
    </custom-select>
    <input
      v-if="hiddenInputName && selectedModel"
      :name="hiddenInputName"
      type="hidden"
      :value="selectedModel.alias ? selectedModel.alias : selected"
    />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import CustomSelect from './custom-select';
import RepoS from '../../services/repository.service';
import sharedComponentsMessages from '../sharedComponentsMessages';

export default {
  name: 'ProjectBranchSelector',
  components: { CustomSelect },
  props: {
    alias: { default: null },
    projectModel: { default: null },
    selected: { default: null },
    redirect: {
      type: Boolean,
      default: false
    },
    hiddenInputName: { default: 'branch-name' },
    clearable: { default: false },
    error: { default: null },
    placeholder: {
      default() {
        return this.$t('select_branch');
      }
    },
    hiddenInputName: { default: 'branch-name' },
    clearable: { default: false },
    selectDefaultBranch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pages: [],
      options: [],
      selectedModel: null,
      observer: null,
      nextPage: 1,
      showLoader: true
    };
  },
  computed: {
    hasNextPage() {
      return this.nextPage < this.pages.totalPages;
    }
  },
  watch: {
    selected() {
      this.selectedModel = this.selected;
      this.observer = new IntersectionObserver(this.infiniteScroll);
      this.options = [];
      if (this.selectedModel) {
        this.options.push(this.selectedModel);
      }
    }
  },
  mounted() {
    this.selectedModel = this.selected;
    this.observer = new IntersectionObserver(this.infiniteScroll);
    if (this.selectedModel) {
      this.options.push(this.selectedModel);
    }
    if (this.selectDefaultBranch) {
      this.getDefaultBranch();
    }
  },
  methods: {
    getOptions(callback) {
      RepoS.getBranches(
        this.alias || this.$route.params.alias,
        this.projectModel || this.$route.params.projectAlias,
        { page: this.nextPage },
        false
      ).then((res) => {
        // eslint-disable-next-line no-underscore-dangle
        this.options.push(...res._embedded.options);
        this.pages = res.page;
        this.nextPage = this.pages.number + 1;
        if (callback) {
          callback();
        }
      });
    },
    getDefaultBranch() {
      RepoS.getBranches(
        this.alias || this.$route.params.alias,
        this.projectModel || this.$route.params.projectAlias,
        { page: 0, size: 1 },
        false
      ).then((res) => {
        // eslint-disable-next-line no-underscore-dangle
        this.selectedModel = res._embedded.options[0];
        this.$emit('input', this.selectedModel);
      });
    },
    onChange(e) {
      this.$emit('input', e);
      if (!this.redirect) return;
      const params = new URLSearchParams(window.location.search);
      params.set('branch', e.id);
      window.location.search = params.toString();
    },
    async onOpen() {
      await this.$nextTick();

      RepoS.getBranches(
        this.alias || this.$route.params.alias,
        this.projectModel || this.$route.params.projectAlias,
        {},
        false
      ).then((res) => {
        // eslint-disable-next-line no-underscore-dangle
        this.options = res._embedded.options;
        this.pages = res.page;
        this.observer.observe(this.$refs.load);
      });
    },
    onClose() {
      this.observer.disconnect();
      this.setDefault();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const { scrollTop } = ul;

        const setScroll = () => {
          this.$nextTick(() => {
            ul.scrollTop = scrollTop;
          });
        };

        if (this.hasNextPage) {
          this.getOptions(setScroll);
        } else {
          this.showLoader = false;
        }
      }
    },
    onSearch(q) {
      if (q.length >= 3 || q.length === 0) {
        setTimeout(() => {
          this.observer.disconnect();
          RepoS.getBranches(this.alias, this.projectModel, { q }, false).then((res) => {
            // eslint-disable-next-line no-underscore-dangle
            if (res?._embedded?.options) {
              // eslint-disable-next-line no-underscore-dangle
              this.options = res._embedded.options;
            } else {
              this.options = [];
            }
            this.showLoader = false;
          });
        }, 500);
      }
    },
    setDefault() {
      this.nextPage = 1;
      this.options = [];
      this.showLoader = true;
      this.observer.disconnect();
    }
  },
  i18n: {
    messages: sharedComponentsMessages
  }
};
</script>

<style lang="scss" scoped>
.project-info {
  &__branch-selector {
    min-width: 100%;

    @media screen and (min-width: 768px) {
      min-width: initial;
    }

    .select-branch {
      @media screen and (min-width: 768px) {
        min-width: 140px;
      }

      &__loader {
        text-align: center;
      }
    }
  }
}
</style>
